export const PINK_ANGLE_COLORS = [0xFC99C4, 0xF94F6F];
export const CENTER_OF_CIRCLE = { x: 600, y: 310 };
export const CIRCLE_RADIUS = 200;
export const INITIAL_INTERSEC_RADIUS = 145;
export const INITIAL_RADIANS = [Math.PI / 2*3, Math.PI / 2 ];
export const ARC_COLOR_ARR = [0x000000, 0x000000];
export const INFO_SLIDER_COORD = { x: 1180, y: 200 };
export const SLIDERS_COORD = [{ x: 70, y: 800 }, { x: 440, y: 800 }, { x: 810, y: 800 }];
export const SLIDERS_COORD_OFFSET_VERTICAL = [{ x: -260, y: 400 }, { x: -260, y: 600 }, { x: 60, y: 400 }];
export const LINE_COLORS = [0x21D4FE, 0xB06EFE, 0xF94F6F, 0xFFF000];
export const INFO_SLIDER_ASSETS_SLUG = "circle-theorem-11";